import { Stack } from '@mui/material';
import VisitCourseCard from 'src/sections/@dashboard/visit/components/VisitCourseCard';
import VisitDetails from 'src/sections/@dashboard/visit/components/VisitDetails';
import VisitDetailsSkeleton from 'src/sections/@dashboard/visit/components/VisitDetailsSkeleton';
import { useCurrentVisitContext } from 'src/sections/@dashboard/visit/hooks/useCurrentVisitContext';

export default function ProfileTabsVisitPage() {
  const { isLoading } = useCurrentVisitContext();

  return (
    <Stack sx={{ height: 1, gap: 3 }}>
      {/* Powód wizyty first — it's the context the professional reads before
          working through Przebieg wizyty, which grows during the visit. */}
      {!isLoading ? <VisitDetails /> : <VisitDetailsSkeleton />}
      <VisitCourseCard />
    </Stack>
  );
}
